// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-awesome/css/font-awesome.min.css
// module id = Xg2D
// module chunks = 24